<!--<h3><font color="red">In Progress</font></h3>-->
<div>
  <h6>I want to search for</h6>
  <app-doc-category-ex2></app-doc-category-ex2>
</div>
<div>
  <h6 m-2>The document was created</h6>
  <app-date-range-ps></app-date-range-ps>
</div>
<div>
  <app-compound-name></app-compound-name>
</div>
<div class="col-sm-4 col-container">
  <app-address></app-address>
</div>
<div class="ct-dropdwn"  >
  <app-city-town-ex></app-city-town-ex>
</div>
<button class="btn btn-default" type="button" [routerLink]='["/property-search-result-pg"]'>
  SEARCH RECORDED AND REGISTERED LAND
</button>
